// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"7d033c26","93":"7d033c26","116":"7d033c26","343":"7d033c26","486":"7d033c26","520":"7d033c26","559":"7d033c26","797":"7d033c26","858":"7d033c26"}[chunkId] + ".chunk.css";
};